export default "__VITE_ASSET__BfmEMYzV__"